import Head from "next/head";
import StartHumming from "pages/components/StartHumming";
import React from "react";
import { ExtendedNextPage } from "types/pages";

import Content from "components/Content";
import Label from "components/Label";
import HummingNav from "pages/components/HummingNav";
import HummingFooter from "pages/components/HummingFooter";
import styles from "./styles.module.scss";
import { privacy } from "./constants";

const Privacy: ExtendedNextPage = () => {
  return (
    <div className={styles.container}>
      <Head>
        <title>Privacy Policy | Humming Homes</title>
        <meta name="description" content="The Humming Homes Privacy Policy " />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Content contentClassName={styles.terms}>
        <Label className={styles.title} variant="h1-centered" color="primary">
          Privacy Policy
        </Label>
        <Label color="primary" useMarkdown>
          {privacy}
        </Label>
      </Content>
      <StartHumming fillColor="primary" />
    </div>
  );
};

Privacy.getLayout = (page) => {
  return (
    <div>
      <HummingNav />
      {page}
      <HummingFooter />
    </div>
  );
};

export default Privacy;
